import { COSMETIC_BY_ID } from "@nano/content";
import { useEffect, useRef } from "react";
import { closePurchaseReveal } from "../../app/actions.ts";
import { useApp } from "../../app/store.ts";
import { itemName } from "../../i18n/content.ts";
import { vi } from "../../i18n/vi.ts";
import { Art, Button } from "../components/common.tsx";
import { centerOf, fx } from "../fx/fx.ts";

/** The moment after a purchase: light rays in the item's rarity colour, the item pops in, confetti. */
export function PurchaseReveal() {
  const itemId = useApp((s) => s.ui.purchaseReveal);
  const artRef = useRef<HTMLDivElement>(null);
  const item = itemId ? COSMETIC_BY_ID.get(itemId) : undefined;
  useEffect(() => {
    if (!item) return;
    const timer = setTimeout(() => {
      const at = centerOf(artRef.current);
      if (!at) return;
      fx.sparkles(at.x, at.y, item.rarity === "epic" ? 26 : 16, 180);
      fx.confetti({ x: at.x, y: at.y, count: item.rarity === "epic" ? 110 : 60, spread: 2, power: 0.9 });
      if (item.rarity === "epic") fx.fireworks(at.x, at.y - 40, 3);
    }, 260);
    return () => clearTimeout(timer);
  }, [item]);
  if (!item) return null;
  return (
    <div className={`reveal reveal--${item.rarity}`} onClick={() => closePurchaseReveal()} data-testid="purchase-reveal">
      <div className="reveal__card" onClick={(event) => event.stopPropagation()}>
        <span className={`reveal__rarity reveal__rarity--${item.rarity}`}>{vi.shop.rarity[item.rarity]}</span>
        <h2 className="reveal__title">{vi.shop.revealTitle}</h2>
        <div className="reveal__stage" ref={artRef}>
          <span className="reveal__rays" aria-hidden="true" />
          <span className="reveal__halo" aria-hidden="true" />
          <Art id={item.assetIds.front} className="reveal__art" alt={itemName(item)} />
        </div>
        <strong className="reveal__name">{itemName(item)}</strong>
        <p className="note">{vi.shop.revealWearing}</p>
        <Button variant="gold" onClick={() => closePurchaseReveal()} testId="reveal-ok">
          {vi.shop.revealOk}
        </Button>
      </div>
    </div>
  );
}
